import { render } from "./ConfirmationComponent.vue?vue&type=template&id=65855640"
import script from "./ConfirmationComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__